import { Medialink } from '../../../../../api/medialink';
import { Module } from '../../../../../api/module';
import { postSmartschoolSkore, SkoreExerciseScore, SkorePayload } from '../../api/smartschool-skore';
import { ResultWithGroup } from '../per-student/hooks/useResults';
import { ScorableItem } from '../../api/scorable-items';

export async function exportToSkore({
  checkedMembersWithResults,
  scorableItem,
  medialink,
  selectedModule,
}: {
  checkedMembersWithResults: { groupId: string; result: ResultWithGroup }[];
  scorableItem: ScorableItem;
  medialink?: Medialink;
  selectedModule: Module;
}) {
  const groupMap = checkedMembersWithResults.reduce((map, { groupId, result }) => {
    if (!map.has(groupId)) map.set(groupId, []);
    map.get(groupId)!.push(result);
    return map;
  }, new Map<string, ResultWithGroup[]>());

  await Promise.all(
    Array.from(groupMap, ([groupId, groupResults]) => {
      const exerciseScores: SkoreExerciseScore[] = groupResults.map(result => ({
        studentId: result.memberId,
        achieved: result.score?.achieved,
        achievedAt: result.achievedAt!,
        sessionId: result.session,
      }));

      const groupMaxScore = Math.max(...groupResults.map(r => r.score.maximum));

      const exercise =
        scorableItem.type === 'medialink' && medialink
          ? {
              id: medialink.id,
              type: 'medialink',
              maxScore: groupMaxScore,
              name: `${scorableItem.isAssignment ? 'Assignment' : 'Exercise'} ${medialink.name}`,
              scores: exerciseScores,
            }
          : {
              id: scorableItem.id.split('-')[0],
              type: 'user-material',
              maxScore: groupMaxScore,
              name: `${scorableItem.isAssignment ? 'Assignment' : 'Exercise'} ${scorableItem.name}`,
              scores: exerciseScores,
            };

      const payload: SkorePayload = {
        groupId,
        subjectName: selectedModule.subjectName,
        exercises: [exercise],
      };

      return postSmartschoolSkore(selectedModule.id, payload);
    }),
  );
}
